import { ReactSession } from "react-client-session";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Principal from "./component/Principal";
import { Toaster } from 'react-hot-toast'
import EncuestaRespond from "./component/Formularios/EncuestaRespond";
import ProtocoloDirectoInicio from "./component/Protocolos/ProtocoloDirectoInicio";
import ReclutamientoPersonal from "./component/Reclutaminetos/ReclutamientoPersonal";
import PrincipalTarjetaMiguel from "./component/PrincipalTarjetaMiguel";
import AutorizarEncuestaGeneral from "./component/Formularios/AutorizarEncuestaGeneral";
const server = process.env.REACT_APP_SERVER;

function App() {
  ReactSession.setStoreType("localStorage");
  window.addEventListener("error", (event) => {
    var info = window.location.origin + ` RRHH ${event.type}: ${event.message}:${event.lineno}:${event.colno}:${event.error}\n`;
    fetch(`${server}/sqlComun/sendMesajeError`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 'mensaje': JSON.stringify(info) })
    })
      .then(res => res.json())
      .then(data => {
        //console.log(data);
      })
      .catch(err => {
        //console.log(err);
      });
  });
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Principal />} />
          <Route path='/Encuesta/*' element={<EncuestaRespond />} />
          <Route path='/EncuestaGeneral/*' element={<AutorizarEncuestaGeneral/>}/>
          <Route path='/VerProtocolos/*' element={<ProtocoloDirectoInicio />} />
          <Route path='/Reclutamiento/*' element={<ReclutamientoPersonal />} />
          <Route path='/TarjetaMiguel' element={<PrincipalTarjetaMiguel/>}/>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
